import React from 'react';
import { useTranslation } from 'react-i18next';

import Rodape from '../../components/Rodape';
import Cabecalho from '../../components/cabecalho/Cabecalho';
import Inicio from '../../components/Inicio';
import Contato from '../../components/Contato';
import HomeHighlights from '../../components/HomeHighlights';
import Planos from '../../components/Planos';
import '../../estilo.css';

export default function Home() {
  const { t } = useTranslation();
  const siteButtons = [
    { titulo: t('nav.robots'), href: '#robos', action: null },
    { titulo: t('nav.indicators'), href: '#indicadores', action: null },
    { titulo: t('nav.results'), href: '/resultados/ragnarok', action: null },
    { titulo: t('nav.plans'), href: '#planos', action: null },
    { titulo: t('nav.contact'), href: '#contact', action: null },
    { titulo: t('nav.createAccount'), href: '/cadastro', action: null },
    { titulo: t('nav.login'), href: '/login', action: null },
  ];

  return (
    <div className="App public-site">
      <Cabecalho buttonList={siteButtons} />

      <Inicio />
      <HomeHighlights />
      <Planos />
      <Contato />
      <Rodape />
    </div>
  );
}
